/*首页功能相关路由*/
const main_map_box = () =>  import("../../studio/main_map_box");

export default [
  {
    path: '/main_map',
    name: '地图页',
    component: main_map_box
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/main_map_page.js